<template>
  <div
    v-outside-click="{
      exclude: [],
      handler: 'closeAddExistingMenu'
    }">
    <button class="bg-sky-200 p-1 rounded-md relative text-sm"
      @click="openAddExistingMenu">
      +
      <div class="absolute inset-0 z-10"
        v-show="showSelector">
        <div class="p-1 bg-white rounded-sm w-32 shadow">
          <SelectionField class="pb-2"
            v-model="addedExistingKey"
            :options="existingKeyList">
            Add Existing Key
          </SelectionField>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import SelectionField from '../../formComponents/SelectionField.vue'

export default {
  components:{
    SelectionField,
  },
  props: {
  },
  data() {
    return {
      showSelector: false,
      addedExistingKey: undefined,

      existingKeyList: {
        vendor_id: 'Vendor ID',
        district_code: 'District Code',
      },
    }
  },
  methods: {
    openAddExistingMenu() {
      this.showSelector = true
    },
    closeAddExistingMenu() {
      this.showSelector = false
      this.addedExistingKey = undefined
    },
    addField() {
      this.$emit('addKey', this.addedExistingKey)
      this.closeAddExistingMenu()
    }
  },
  watch: {
    addedExistingKey(newValue) {
      if (newValue !== undefined) {
        this.addField()
      }
    },
  },
}
</script>
